import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./IconoNuevaFuncionalidad.css";

const CLAVE_LOCALSTORAGE = "funcionalidades-nuevas";

const IconoNuevaFuncionalidad = ({ funcionalidad, fechaLimiteVisible, diasVisible }) => {
  const [mostrar, setMostrar] = useState(false);

  useEffect(() => {
    const ahora = new Date();
    const fechaLimite = new Date(fechaLimiteVisible);

    const funcionalidadesGuardadas = localStorage.getItem(CLAVE_LOCALSTORAGE);
    let funcionalidades = funcionalidadesGuardadas ? JSON.parse(funcionalidadesGuardadas) : {};

    if (!funcionalidades[funcionalidad]) {
      funcionalidades[funcionalidad] = ahora.toISOString();
      localStorage.setItem(CLAVE_LOCALSTORAGE, JSON.stringify(funcionalidades));
    }

    const primeraVez = new Date(funcionalidades[funcionalidad]);

    const fechaExpiracion = new Date(primeraVez);
    fechaExpiracion.setDate(fechaExpiracion.getDate() + diasVisible);

    const debeMostrar = ahora <= fechaExpiracion && ahora <= fechaLimite;

    setMostrar(debeMostrar);
  }, [funcionalidad, fechaLimiteVisible, diasVisible]);

  if (!mostrar) return null;

  return <i className="fas fa-circle fa-xs icon-glow ml-1"></i>;
};

IconoNuevaFuncionalidad.propTypes = {
  funcionalidad: PropTypes.string.isRequired, // Nombre único de la funcionalidad
  fechaLimiteVisible: PropTypes.string.isRequired, // Fecha límite para que se muestre, independientemente de los días visible. Formato "YYYY-MM-DD"
  diasVisible: PropTypes.number,
};

IconoNuevaFuncionalidad.defaultProps = {
  diasVisible: 7,
};

export default IconoNuevaFuncionalidad;
